import { render } from "./OrderPage.vue?vue&type=template&id=b7223e18&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=b7223e18&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7223e18"]])

export default __exports__